/* eslint-disable @nx/enforce-module-boundaries */
'use client'

// core (MUI)
import { arSA as arSACore, enUS as enUSCore, frFR as frFRCore, itIT as itITCore, viVN as viVNCore, zhCN as zhCNCore } from '@mui/material/locale'
// data grid (MUI)
import {
  arSD as arSDDataGrid,
  enUS as enUSDataGrid,
  frFR as frFRDataGrid,
  itIT as itITDataGrid,
  viVN as viVNDataGrid,
  zhCN as zhCNDataGrid
} from '@mui/x-data-grid/locales'
// date pickers (MUI)
// import { enUS as enUSDate, frFR as frFRDate, viVN as viVNDate, zhCN as zhCNDate } from '@mui/x-date-pickers/locales'
import { enUS as enUSDate, frFR as frFRDate, itIT as itITDate, zhCN as zhCNDate } from '@mui/x-date-pickers/locales'

// --------------------------------------------------------------------------------------------- //

export const allLangs = [
  {
    value: 'en',
    label: 'English',
    countryCode: 'GB',
    adapterLocale: 'en',
    numberFormat: { code: 'en-US', currency: 'USD' },
    systemValue: {
      components: { ...enUSCore.components, ...enUSDate.components, ...enUSDataGrid.components }
    }
  },
  {
    value: 'it',
    label: 'Italian',
    countryCode: 'IT',
    adapterLocale: 'it',
    numberFormat: { code: 'it-IT', currency: 'EUR' },
    systemValue: {
      components: { ...itITCore.components, ...itITDate.components, ...itITDataGrid.components }
    }
  },
  {
    value: 'fr',
    label: 'French',
    countryCode: 'FR',
    adapterLocale: 'fr',
    numberFormat: { code: 'fr-Fr', currency: 'EUR' },
    systemValue: {
      components: { ...frFRCore.components, ...frFRDate.components, ...frFRDataGrid.components }
    }
  },
  {
    value: 'vi',
    label: 'Vietnamese',
    countryCode: 'VN',
    adapterLocale: 'vi',
    numberFormat: { code: 'vi-VN', currency: 'VND' },
    systemValue: {
      // components: { ...viVNCore.components, ...viVNDate.components, ...viVNDataGrid.components }
      components: { ...viVNCore.components, ...viVNDataGrid.components }
    }
  },
  {
    value: 'cn',
    label: 'Chinese',
    countryCode: 'CN',
    adapterLocale: 'zh-cn',
    numberFormat: { code: 'zh-CN', currency: 'CNY' },
    systemValue: {
      components: { ...zhCNCore.components, ...zhCNDate.components, ...zhCNDataGrid.components }
    }
  },
  {
    value: 'ar',
    label: 'Arabic',
    countryCode: 'SA',
    adapterLocale: 'ar-sa',
    numberFormat: { code: 'ar', currency: 'AED' },
    systemValue: {
      components: { ...arSACore.components, ...arSDDataGrid.components }
    }
  }
]

/**
 * Country code:
 * https://flagcdn.com/en/codes.json
 *
 * Number format code:
 * https://gist.github.com/raushankrjha/d1c7e35cf87e69aa8b4208a8171a8416
 */
